import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './change-password.component'

let module = angular.module('changePassword', [
  uiRouter
])
.config(($stateProvider) => {
  'ngInject'
  $stateProvider
    .state('changePassword', {
      url: '/change-password',
      component: 'changePassword',
      authenticate: true
    })
})
.component('changePassword', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/change-password/index.js